@if(isDisabled){
<app-loader></app-loader>
}
<div class="card">
    <div class="card-header">
        <div class="row">
            <div class="col">User Applicability</div>
            <div class="col-md-3">
                <div class="input-group">
                    <div class="input-group-text"><i class="bi bi-search"></i></div>
                    <input type="text" class="form-control" placeholder="Search Here.."
                        (keyup)="SearchDropdown($any($event.target).value,'Applicability')">
                </div>
            </div>
            <div class="col-auto">
                <button type="button" class="btn btn-outline-primary" [disabled]="isDisabled"
                    (click)="ButtonApplicabilityDataFilter()"><i class="bi bi-funnel" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Filter':'Loading...'}}</button>
            </div>
        </div>
    </div>
    <div class="card-body">
        <div class="row">
            <div class="col-auto">
                <label class="mt-1">User <span class="text-danger">*</span></label>
            </div>
            <div class="col-md-6">
                <ng-select name="approvaluser" placeholder="Select User" [items]="Users" bindLabel="UserName"
                    bindValue="UserMasterId" [(ngModel)]="ShiftRuleDetail.UserMasterID">
                </ng-select>
                <div class="invalid-feedback fs-7">
                    Please select user
                </div>
            </div>
            <div class="col-auto">
                <button (click)="GetApplicabilityAccess()" class="btn btn-primary btn-sm">
                    Load
                </button>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-md-2">
                <div class="btn-group btn-group-toggle d-flex flex-column bg-light">
                    @for (Applicability of Applicabilitys; track Applicability.WebESSUserApplicabilityMasterID; let i =
                    $index) {
                    <label class="form-check-label text-label-dark px-1" ngbButtonLabel>
                        <input class="form-check-input" type="radio" [value]=Applicability.WebESSUserApplicabilityMasterID
                            name='WebESSUserApplicabilityMasterID'
                            [(ngModel)]="ShiftRuleDetail.WebESSUserApplicabilityMasterID"
                            [ngModelOptions]="{standalone: true}" (change)="ApplicabilityDataFilter()"
                            [disabled]="Applicability.WebESSApplicabilityMasterID == 0">
                        {{Applicability.ApplicabilityName}}
                        <i *ngIf="Applicability.WebESSUserApplicabilityMasterID == 3 || Applicability.WebESSUserApplicabilityMasterID == 7"
                            class="bi bi-funnel"></i>
                    </label>
                    }
                </div>
            </div>
            <div class="col-md-10">
                <div class="row">
                    <div class="form-check" *ngIf="ApplicabilityDatas.length > 0">
                        <input class="form-check-input" type="checkbox" value="" id="SelectAll"
                            (change)="ApplicabilityCheckAll($event)">
                        <label for="SelectAll">
                            Select All
                        </label>
                    </div>
                </div>
                <div class="row">
                    <label
                        *ngIf="ApplicabilityDatas.length == 0 && ShiftRuleDetail.WebESSUserApplicabilityMasterID > 0">Please
                        select filter</label>
                    @for (ApplicabilityData of OrderByApplicability(); track
                    ApplicabilityData.ApplicabilityDataID;
                    let i = $index) {
                    <div class="col-md-4">
                        <div class="form-check" *ngIf="ApplicabilityDatas.length > 0">
                            <input class="form-check-input" type="checkbox"
                                id="ChkOut{{ApplicabilityData.ApplicabilityDataID}}"
                                name="ChkOut{{ApplicabilityData.ApplicabilityDataID}}"
                                [(ngModel)]="ApplicabilityData.IsCheck">
                            <label class="form-check-label applicability-font"
                                for="ChkOut{{ApplicabilityData.ApplicabilityDataID}}">
                                {{ApplicabilityData.ApplicabilityData}}
                            </label>
                        </div>
                    </div>
                    }
                </div>
            </div>
        </div>
    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col"></div>
            <div class="col-auto">
                <button [routerLink]="['/master/userdetail/applicability']" class="btn btn-outline-primary btn-sm">
                    Cancel
                </button>
            </div>
            <div class="col-auto">
                <button (click)="Save()" class="btn btn-primary btn-sm">
                    Save
                </button>
            </div>
        </div>
    </div>
</div>